<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="['/machinegroups']" [queryParams]="{search: searchTerm}"><span
    translate>Machinery group</span></a></li>
    <li class="breadcrumb-item active" aria-current="page">
      <span translate>Configuration</span>:&nbsp;
      @if (machineGroup) {
        <span [innerText]="machineGroup.name"></span>
      }
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <div class="card nav-vertical">
      <div class="card-header"><i class="fa-solid fa-bars"></i><span translate>Configuration</span></div>
      <ul ngbNav orientation="vertical" [(activeId)]="show" (navChange)="onNavChange($event)">
        <li ngbNavItem="machines">
          <a (click)="onMenuClick(menuItems.MACHINES)" ngbNavLink translate>Machine</a>
        </li>
        <li ngbNavItem="users">
          <a (click)="onMenuClick(menuItems.USERS)" ngbNavLink translate>Users</a>
        </li>
        <li ngbNavItem="groups">
          <a (click)="onMenuClick(menuItems.GROUPS)" ngbNavLink translate>Group</a>
        </li>
        <li class="divider my-0"></li>
        <li ngbNavItem="trigger-action">
          <a (click)="onMenuClick(menuItems.TRIGGER_ACTION)" ngbNavLink translate>Trigger action</a>
        </li>
        <li ngbNavItem="trigger-configuration">
          <a (click)="onMenuClick(menuItems.TRIGGER_CONFIGURATION)" ngbNavLink translate>Trigger configuration</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="col-12 col-lg">
    <div class="tab-container">

      @if (show === menuItems.MACHINES && machineGroup) {
        <scitis-admin-machine-group-machines
          [machineGroupName]="machineGroup.name"
          [machineGroupId]="machineGroup.id"
          [whiteListedMachineryGroups]="whiteListedMachineryGroups">
        </scitis-admin-machine-group-machines>
      }

      @if (show === menuItems.USERS && machineGroup) {
        <scitis-admin-machine-group-users
          [machineGroupName]="machineGroup.name"
          [machineGroupId]="machineGroup.id"
          [whiteListedMachineryGroups]="whiteListedMachineryGroups">
        </scitis-admin-machine-group-users>
      }

      @if (show === menuItems.GROUPS && machineGroup) {
        <scitis-admin-machine-group-groups
          [machineGroupName]="machineGroup.name"
          [machineGroupId]="machineGroup.id"
          [whiteListedMachineryGroups]="whiteListedMachineryGroups">
        </scitis-admin-machine-group-groups>
      }

      @if (show === menuItems.TRIGGER_ACTION && machineGroup) {
        <scitis-admin-machine-group-trigger-action
          [machineGroupId]="machineGroup.id"
          [userRole]="userRole">
        </scitis-admin-machine-group-trigger-action>
      }

      @if (show === menuItems.TRIGGER_CONFIGURATION && machineGroup) {
        <scitis-admin-machine-group-trigger-configuration
          [userRole]="userRole"
          [machines]="machineGroup.machines"
          [machineGroupId]="machineGroup.id">
        </scitis-admin-machine-group-trigger-configuration>
      }

    </div>
  </div>
</div>
